/**
 * agentesDaExecucao.js — regras de apresentação dos agentes de uma execução (SPEC A3,
 * FR-19..FR-22). Funções puras, sem I/O. Nunca inventam número: valor ausente vira
 * "sem histórico" / "—", não zero.
 */

/** US$ em pt-BR ("US$ 1,23"); null/undefined/NaN → null (quem chama mostra o texto). */
export function usd(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  const n = Number(valor);
  if (!Number.isFinite(n)) return null;
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'USD' });
}

/** Inteiro em pt-BR; ausente → '—'. */
export function inteiro(valor) {
  const n = Number(valor);
  if (valor === null || valor === undefined || !Number.isFinite(n)) return '—';
  return n.toLocaleString('pt-BR');
}

/** Rótulo pt-BR das etapas do pipeline (o id cru aparece se não houver rótulo). */
export const ROTULO_DA_ETAPA = {
  extract_requirements: 'Requisitos',
  ideation: 'Ideação',
  design_plan: 'Design',
  dados: 'Dados',
  testes_integracao: 'Testes de integração',
  servicos: 'Serviços',
  telas_web: 'Telas web',
  telas_mobile: 'Telas mobile',
  docs: 'Docs',
  infra_cloud: 'Infra cloud',
};

export function rotuloDaEtapa(etapa) {
  return ROTULO_DA_ETAPA[etapa] ?? String(etapa ?? '—');
}

/** Rótulo pt-BR dos blocos do prompt efetivo (FR-4). */
export const ROTULO_DA_PARTE = {
  especialista: 'Especialista',
  skills: 'Skills',
  memoria: 'Memória',
  tarefa: 'Tarefa',
  regras: 'Regras',
};

export function rotuloDaParte(parte) {
  return ROTULO_DA_PARTE[parte] ?? String(parte ?? '—');
}

/** Ordem estável dos blocos: os conhecidos primeiro, depois os demais. */
export function partesOrdenadas(partes) {
  if (!partes || typeof partes !== 'object') return [];
  const conhecidas = Object.keys(ROTULO_DA_PARTE).filter((k) => k in partes);
  const outras = Object.keys(partes).filter((k) => !(k in ROTULO_DA_PARTE));
  return [...conhecidas, ...outras].map((k) => [k, partes[k]]);
}

/** Selo do prompt (A2 FR-7) → texto pt-BR. */
export const TEXTO_DO_SELO_PROMPT = {
  especialista: '✅ especialista',
  sem_prompt: '⚠️ sem prompt de especialista',
  incompleto: '⚠️ incompleto',
  conflito: '⚠️ conflito com regras',
};

/** Rótulo da origem do responsável pela etapa (FR-11). */
export const TEXTO_DA_ORIGEM = {
  aprovado: 'aprovado',
  proposto: 'proposto',
  papel_padrao: 'papel padrão',
};

/** Lista de um array (ou `{items}`), descartando o que não for objeto. */
export function lista(data) {
  const arr = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
  return arr.filter((x) => x && typeof x === 'object');
}
